import { AppUtils } from '../../utils/index';

/**
 * Model for advertising conscent checks
 */
export class WerbeZustimmungModel {
	private einwilligung: boolean;
	private email: boolean;
	private print: boolean;
	private telefon: boolean;

	get Einwilligung(): boolean {
		return this.einwilligung;
	}

	set Einwilligung(value: boolean) {
		this.einwilligung = value;
	}

	get Email(): boolean {
		return this.email;
	}

	set Email(value: boolean) {
		this.email = value;
	}

	get Print(): boolean {
		return this.print;
	}

	set Print(value: boolean) {
		this.print = value;
	}

	get Telefon(): boolean {
		return this.telefon;
	}

	set Telefon(value: boolean) {
		this.telefon = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	static createFromObject(dataObject: { [key: string]: any }): WerbeZustimmungModel {
		return AppUtils.Helper.createFromMap(dataObject, WerbeZustimmungModel);
	}
}